import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Navbar } from "./components/Navbar/Navbar";
import { Hero } from "./components/Hero/Hero";
import { About } from "./components/About/About";
import { ExperienceSkills } from './components/Experienceskills/ExperienceSkills';
import { Project } from './components/Project/Project';
import { Context } from './components/Context/Context'; // ✅ if file is named Context.js


function App() {

 useEffect(() => {
  AOS.init({ duration: 500,  once: true, offset: 80});
}, []);
  
  return (
    <div className="App">
      <Navbar/>
       <Hero />
        <About />
        <ExperienceSkills/>
        <Project/>
        <Context/>
        
    </div>
  );
}

export default App;
